import React, { useEffect, useState } from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
import { load } from "@cashfreepayments/cashfree-js";
import { useNavigate } from "react-router-dom";
import userAxiosInstance from "../../config/userAxiosInterceptor";

const PricingPlans = () => {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  const createOrder = async ({ amount, planId }) => {
    try {
      const { data } = await userAxiosInstance.post(`/app/plan/createOrder`, { amount, planId });
      return { data }
    } catch (error) {
      return { data: error }
    }
  }
  let cashfree;
  var initializeSDK = async function () {
    cashfree = await load({
      mode: "production"
    });
  }
  initializeSDK();

  const doPayment = async (amount, planId) => {
    const userExist = localStorage.getItem("_USER_TOKEN_")
    if (!userExist) {
      window.location.href = "/"
    }
    setIsModalOpen(true)
    const { data } = await createOrder({ amount, planId });
    let checkoutOptions = {
      paymentSessionId: data?.data?.payment_session_id,
      redirectTarget: document.getElementById("cf_checkout"),
      appearance: {
        width: "425px",
        height: "700px",
      },
    };
    cashfree.checkout(checkoutOptions).then((result) => {
      if (result.error) {
        setIsModalOpen(false)
        // This will be true when there is any error during the payment
        console.log("There is some payment error, Check for Payment Status");
        console.log(result.error);
      }
      if (result.redirect) {
        setIsModalOpen(false)

        // This will be true when the payment redirection page couldnt be opened in the same window
        // This is an exceptional case only when the page is opened inside an inAppBrowser
        // In this case the customer will be redirected to return url once payment is completed
        console.log("Payment will be redirected");
      }
      if (result.paymentDetails) {

        // This will be called whenever the payment is completed irrespective of transaction status
        console.log("Payment has been completed, Check for Payment Status");
        console.log(result.paymentDetails.paymentMessage);
        navigate("/user/profile")
        setIsModalOpen(false)

      }
    });
  }


  useEffect(() => {
    fetch(`${process.env.REACT_APP_BASEURL4}/admin/plan/getPlan`) // Replace with actual API endpoint
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          setPlans(data.plans);
        }
      })
      .catch((error) => console.error("Error fetching plans:", error))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="container py-5 bg-white" style={{ position: "relative" }}>
      <h1 className="text-center mb-4" style={{ fontWeight: "bolder" }}>Welcome to the MASTISHORTS TECHNOLOGY PRIVATE LIMITED</h1>
      <h2 className="text-center mb-4">Our Plans And Pricing</h2>
      <h4 className="text-center mb-4">To access the plan
        <a target="_blank" href="https://play.google.com/store/apps/details?id=com.mastiindia&pcampaignid=web_share"> Click here </a> to install app.
      </h4>
      {loading ? (
        <p className="text-center">Loading...</p>
      ) : (
        <div className="row">
          {plans.map((plan, index) => (
            <div key={plan._id} className="col-md-4  column-gap-3" style={{ marginBottom: "12px" }}>
              <div className="border rounded-3 shadow-sm text-center bg-info" style={{ padding: "8px", border: "2px solid black", borderRadius: "20px", cursor: "pointer" }}>
                <h2 className="">For INR {plan.rs}</h2>
                <h3 className="">Get {plan.coins} coins</h3>
                <button type="submit" class="btn btn-primary" id="renderBtn" onClick={() => doPayment(parseInt(plan.rs), plan._id)}>
                  Purchase
                </button>
                {/* <button className="btn btn-primary w-100">Buy Now</button> */}
              </div>
            </div>
          ))}
        </div>
      )}
      {/* Modal */}
      {isModalOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            zIndex: 9999,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.4)",
            backdropFilter: "blur(5px)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            id="cf_checkout"
            style={{
              backgroundColor: "#fff",
              padding: "1rem",
              borderRadius: "8px",
              width: "425px",
              height: "700px",
              boxShadow: "0 4px 15px rgba(0,0,0,0.3)",
            }}
          ></div>
        </div>
      )}

    </div>
  );
};

export default PricingPlans;
